export default __webpack_public_path__ + "static/media/vehicle_package.8d3c1c67.svg";